module.exports = __webpack_public_path__ + "static/gupcakes-603c45d88175b7f0d1582a41a7244227.png";